import { S2AHttpClient } from '@s2a/ng-common';
import { Injectable, NgModule, defineInjectable, inject } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var compareProductTypeIntervals = function (a, b) {
    /** @type {?} */
    var aStart = parseInt(a.start, 10);
    /** @type {?} */
    var bStart = parseInt(b.start, 10);
    if (aStart > bStart) {
        return 1;
    }
    if (aStart < bStart) {
        return -1;
    }
    return 0;
};
/** @type {?} */
var getDuration = function (previous, next) {
    if (previous === undefined || next === undefined) {
        return undefined;
    }
    return parseInt(next.start, 10) - parseInt(previous.start, 10);
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SortService = /** @class */ (function () {
    function SortService(s2aHttpClient) {
        this.s2aHttpClient = s2aHttpClient;
    }
    /**
     * @param {?} machineId
     * @return {?}
     */
    SortService.prototype.getSortNames = /**
     * @param {?} machineId
     * @return {?}
     */
    function (machineId) {
        return this.s2aHttpClient.get("readykit/sortnames/" + machineId);
    };
    SortService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    SortService.ctorParameters = function () { return [
        { type: S2AHttpClient }
    ]; };
    /** @nocollapse */ SortService.ngInjectableDef = defineInjectable({ factory: function SortService_Factory() { return new SortService(inject(S2AHttpClient)); }, token: SortService, providedIn: "root" });
    return SortService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var NgSortsModule = /** @class */ (function () {
    function NgSortsModule() {
    }
    /**
     * @return {?}
     */
    NgSortsModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: NgSortsModule,
            providers: [
                SortService
            ]
        };
    };
    NgSortsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [],
                    declarations: [],
                    exports: []
                },] }
    ];
    return NgSortsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { compareProductTypeIntervals, getDuration, SortService, NgSortsModule };

//# sourceMappingURL=s2a-ng-sorts.js.map